import { useCallback } from 'react';
import { sendMessage, sendBackMessage } from '../utils/messaging';
import { validateTransaction } from '../services/api';
import { PLATFORMS } from '../constants';

export const useLivenessCallbacks = ({ platform, isMovil, transactionId, urlServiceLiveness, onFinish, onResult }) => {

    const handleComplete = useCallback(async () => {
        try {
            const result = await validateTransaction(urlServiceLiveness, transactionId);
            
            const data = {
                success: true,
                transactionId,
                isAlive: result.isAlive,
                isFraud: result.isFraud,
                image: result.image
            };
            
            onResult?.(data);
            
            const baseMessage = { type: 'success', status: 'success', data };
            
            if (platform === PLATFORMS.WEB && !isMovil) {
                sendMessage(platform, isMovil, { origin: 'liveness', ...baseMessage });
            } else {
                sendMessage(platform, isMovil, baseMessage);
            }
        } catch (error) {
            const errorData = {
                type: 'error-intern',
                step: 'validation_failed',
                data: 'validation_failed',
                message: error.message
            };
            
            onResult?.({ error: true, message: error.message });
            
            if (platform === PLATFORMS.WEB && !isMovil) {
                sendMessage(platform, isMovil, { origin: 'liveness', ...errorData });
            } else {
                sendMessage(platform, isMovil, errorData);
            }
        }
        onFinish?.();
    }, [platform, isMovil, transactionId, urlServiceLiveness, onFinish, onResult]);

    const handleError = useCallback((error) => {
        const errorData = {
            type: 'error-intern',
            step: error.code || 'sdk_error',
            data: error.code || 'sdk_error',
            message: error.message
        };

        onResult?.({ error: true, message: error.message });

        if (platform === PLATFORMS.WEB && !isMovil) {
            sendMessage(platform, isMovil, { origin: 'liveness', ...errorData });
        } else {
            sendMessage(platform, isMovil, errorData);
        }
        onFinish?.();
    }, [platform, isMovil, onResult, onFinish]);

    const handleClose = useCallback(() => {
        sendBackMessage(platform, isMovil);
        onFinish?.();
    }, [platform, isMovil, onFinish]);

    return { handleComplete, handleError, handleClose };
};
